<ng-container *transloco="let t">
  <app-page-template [showBreadcrumbs]="false">
    <div class="container">
      <div class="row">
        <div class="col">
          <app-styled-header-box
            [text]="calendarType === EventItemType.FINISHED ? t('event.calendar.finished.events') : t('event.calendar.event.calendar')"
            [withBackground]="withBackground">
          </app-styled-header-box>
        </div>
      </div>
    </div>
    <ng-template [ngTemplateOutlet]="searchFrom"></ng-template>
    @if (eventMapVisible) {
      <ng-template [ngTemplateOutlet]="eventMap"></ng-template>
    } @else {
      <ng-template [ngTemplateOutlet]="eventList"></ng-template>
    }
  </app-page-template>

  <ng-template #searchFrom>
    <form #filterRacesForm="ngForm">
      <div class="container position-relative d-flex flex-column">

        <div class="d-flex align-items-center position-relative pb-3 px-md-0 flex-row justify-content-start justify-content-lg-center align-items-xxl-center filter-box">
          <ng-container *ngTemplateOutlet="searchBar"></ng-container>
        </div>

          <div class="d-flex align-items-center mb-3 px-10">

            <div class="d-none d-md-flex align-items-center">
              <ng-container *ngTemplateOutlet="filters"></ng-container>
            </div>

            <div class="container d-flex d-md-none px-0">
              <div class="filter-bar">
                <ng-container *ngTemplateOutlet="filters"></ng-container>
              </div>
            </div>

        <ng-template #filters>
          <div class="pe-0 pe-md-1 pe-lg-0">
            <app-month-picker-mobile [disablePastMonths]="calendarType === EventItemType.UPCOMING" [disableFutureMonths]="calendarType === EventItemType.FINISHED"
                                     [title]="t('app.common.date')" [chosenFrom]="chosenMonthRange" [chosenTo]="chosenMonthRange"
                                     (monthsSelected)="dateChanged($event)"/>
          </div>

          <div class="pe-0 pe-md-1 pe-lg-0">
            <app-filter-item [title]="t('app.common.sport')"
                           [items]="sportsItems"
                           id="sportsFilter" [allowSearchItems]="true"
                           (onChange)="onFilterChange($event, 'activity')"
          />
          </div>
          <div class="pe-0 pe-md-1 pe-lg-0">
            <app-filter-item [title]="t('app.common.country')"
                           [items]="countriesItems"
                           id="countriesFilter"
                           (onChange)="onFilterChange($event, 'location')"/>
          </div>
          <div class="pe-0 pe-md-1 pe-lg-0">
            <app-filter-item [title]="t('explore.races.length')"
                             [items]="lengthItems"
                             id="lengthFilter"
                             [isMultiSelect]="false"
                             (onChange)="onFilterChange($event, 'distance')"/>
          </div>
          </ng-template>
        </div>
      </div>

      <div class="container d-flex">
        <div class="active-filters" [ngStyle]="{ 'padding-bottom': showClearAll ? '20px' : '0' }">
          <ng-container *ngIf="chosenMonthRange">
            <button type="button" class="filter-chip-active" >
              <span>{{ t('app.common.date') }}:
                {{ dateFrom | dateRangePipe:dateTo}}
              </span>
              <span class="cursor-pointer" (click)="dateChanged()">
                  <img src="./assets/img/svg/close.svg" alt="Close" class="cursor-pointer close-icon">
                </span>
            </button>
          </ng-container>
          <ng-container *ngFor="let group of filterGroups">
            <ng-container *ngFor="let filter of group.items">
              <button type="button" class="filter-chip-active" *ngIf="filter.selected">
                <span>{{ group.label }}: {{ filter.labelKey ? t(filter.labelKey) : (filter.label ?? "-" ) }}</span>
                <span class="cursor-pointer" (click)="removeFilter(group.items, filter)">
                  <img src="./assets/img/svg/close.svg" alt="Close" class="cursor-pointer close-icon">
                </span>
              </button>
            </ng-container>
          </ng-container>

          <button
            *ngIf="showClearAll"
            type="button"
            class="filter-chip-active"
            (click)="clearAllFilters()">
            Clear All
          </button>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #eventList>
    <div class="padding-bottom-92 pb-300-100">
      <section class="next-race-section upper-section-background">
        <div class="container">
          <app-loader [isLoading]="isLoading"></app-loader>
          <section>
            @if (listOfEvents.length ?? 0 > 0) {
              <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
                @for (item of listOfEvents; track trackByFn) {
                  <div class="col mb-4">
                    <div class="px-10 p-sm-0">
                      <app-event-grid-item-with-image-alt [eventItem]="item" [countries]="countries" [isLanding]="true"
                                                          (onRightButtonClickCallback)="goToEventDetailsPage(item, this.calendarType === EventItemType.FINISHED)"
                                                          [languages]="languages"
                                                          [isFinishedEvent]="this.calendarType === EventItemType.FINISHED"/>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <app-empty-state/>
            }
            @if ((listOfEvents.length ?? 0 > 0) && hasMoreEvents) {
              <div class="d-flex justify-content-center load-more-wrapper">
                <app-button-alt [text]="t('app.common.load.more.events')" [borderColor]="'var(--teal-500)'"
                                [textColor]="'var(--grey-neutral-800)'" (onClickCallback)="loadMore()"
                                [buttonColor]="'transparent'"/>
              </div>
            }
          </section>
        </div>
      </section>
      @if ((listOfEvents.length ?? 0 > 0) && showFabButton) {
        <div (click)="scrollToTop()" class="scroll-to-top">
          <i class="bi bi-arrow-up"></i>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #eventMap>
    <div>
      <section class="pb-300-100">
        <div class="container">
          <app-loader [isLoading]="isLoading"></app-loader>
          <section>
            <app-leaflet-maps-wrapper [lat]="lat" [lng]="lng" [points]="waypointList" [languages]="languages"
                                      [countries]="countries" [mapOnEventCalendar]="true" [increaseMapHeight]="true"/>
          </section>
        </div>
      </section>
    </div>
  </ng-template>

  <ng-template #searchBar>
    <div class="search-wrapper me-3 flex-grow-1 px-10">
      <app-search [searchBarClass]="'extra-small'" (searchQuery)="handleInput($event)" [inputValue]="name"
                  [placeholder]="t('search.placeholder.races')"/>
    </div>
  </ng-template>
</ng-container>
